
export const getTypeSelection = async (resource) => {
    let type_selection;
    await resource
      .get(`api/${localStorage.getItem('perfil')}/type_selection`)
      .then(
        (response) => {
          console.log(response);
          type_selection = response.body.data;
        },
        (response) => {
          console.log(response);
        }
      );
    return type_selection;
}
  